import React, { useState } from "react";
import BookConsultModal from "../BookConsultModal";
import wp1 from "../../assets/leaks1.jpg";
import wp2 from "../../assets/leak2.jpg";
import wp3 from "../../assets/leak3.jpg";
import wp4 from "../../assets/leak4.jpg";

const LeakDetectionCinematic = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-[#fafafa] text-gray-800">

    {/* INTRO HERO */}
<section className="relative h-screen flex items-center justify-center text-center px-6">
  {/* Background Image */}
  <img
    src={wp1}
    alt="Leak Detection Hero"
    className="absolute inset-0 w-full h-full object-cover"
  />

  {/* Semi-transparent dark overlay (subtle, so bg is visible) */}
  <div className="absolute inset-0 bg-black/30"></div>

  {/* Content */}
  <div className="relative z-10 max-w-3xl">
    <p className="uppercase tracking-widest text-amber-500 font-bold mb-4 drop-shadow-md">
      Leak Detection Service
    </p>
    <h1 className="text-5xl md:text-6xl font-serif leading-tight mb-6 text-white drop-shadow-xl">
      Most leaks are invisible.<br />Until it’s too late.
    </h1>
    <p className="text-white text-lg mb-10 drop-shadow-md">
      We find hidden water leaks inside walls, slabs and ceilings using
      non-invasive professional detection methods.
    </p>
    <button
      onClick={() => setIsModalOpen(true)}
      className="
        px-12 py-4 rounded-full 
        bg-amber-600 text-white 
        font-medium shadow-lg
        hover:scale-105 transition
      "
    >
      Book Free Inspection
    </button>
  </div>
</section>
      {/* STORY SECTION */}
      <section className="py-40 bg-white">
        <div className="max-w-4xl mx-auto px-6 relative">

          <div className="absolute left-1/2 top-0 w-[2px] h-full bg-gradient-to-b from-transparent via-amber-400 to-transparent opacity-40" />

          {/* CHAPTER 1 */}
          <div className="grid md:grid-cols-2 gap-20 items-center mb-40">
            <div className="md:text-right">
              <h2 className="text-5xl font-serif mb-4">Chapter I</h2>
              <p className="text-gray-600 text-lg">
                Leaks start deep inside concrete slabs where they remain hidden
                for months before showing any visible signs.
              </p>
            </div>
            <img src={wp2} className="rounded-3xl shadow-xl" />
          </div>

          {/* CHAPTER 2 */}
          <div className="grid md:grid-cols-2 gap-20 items-center mb-40">
            <img src={wp3} className="rounded-3xl shadow-xl" />
            <div>
              <h2 className="text-5xl font-serif mb-4">Chapter II</h2>
              <p className="text-gray-600 text-lg">
                Moisture spreads silently through electrical ducts, ceilings and
                internal walls — weakening structure without warning.
              </p>
            </div>
          </div>

          {/* CHAPTER 3 */}
          <div className="grid md:grid-cols-2 gap-20 items-center">
            <div className="md:text-right">
              <h2 className="text-5xl font-serif mb-4">Chapter III</h2>
              <p className="text-gray-600 text-lg">
                By the time mold appears and paint peels, internal damage is
                already severe and repairs become expensive.
              </p>
            </div>
            <img src={wp4} className="rounded-3xl shadow-xl" />
          </div>
        </div>
      </section>
    {/* SIGNS - PREMIUM */}
<section className="relative py-28 bg-gradient-to-b from-[#fffaf3] to-white overflow-hidden">
  
  {/* soft background blobs */}
  <div className="absolute top-0 left-0 w-72 h-72 bg-amber-200/30 rounded-full blur-3xl" />
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-200/30 rounded-full blur-3xl" />

  <div className="relative max-w-6xl mx-auto px-6">
    
    {/* Heading */}
    <div className="text-center mb-20">
      <span className="uppercase tracking-[0.3em] text-xs text-amber-600 font-semibold">
        Warning Signs
      </span>
      <h2 className="text-4xl md:text-5xl font-serif font-bold text-neutral-900 mt-3 mb-4">
        Signs You Need Leak Detection
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto">
        If you notice any of these symptoms, there may be a hidden water leak
        inside your walls, ceilings, or plumbing system.
      </p>
    </div>

    {/* Cards */}
    <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
      {[
        "Water stains on ceiling",
        "Sudden increase in water bill",
        "Damp smell in rooms",
        "Mold or fungus patches",
        "Cracks near plumbing",
        "Paint bubbling",
        "Constant wall moisture",
        "Hidden dripping sounds"
      ].map((item, i) => (
        <div
          key={i}
          className="
            group bg-white/70 backdrop-blur-xl 
            border border-white/40 
            rounded-3xl p-8 
            shadow-lg hover:shadow-2xl 
            transition-all duration-500
            hover:-translate-y-2
          "
        >
          <div className="w-12 h-12 mb-5 rounded-full 
            bg-amber-100 text-amber-600 
            flex items-center justify-center 
            font-bold text-lg">
            !
          </div>

          <p className="text-gray-800 font-medium leading-relaxed">
            {item}
          </p>
        </div>
      ))}
    </div>

  </div>
</section>

     {/* HOW WE WORK */}
<section className="py-32 bg-[#f7f7f7] text-center">
  <h2 className="text-amber-600 text-5xl font-serif font-bold mb-10">
    How We Detect Leaks
  </h2>
  <p className="text-gray-600 max-w-2xl mx-auto text-lg mb-20">
    No breaking. No guesswork. Only precise professional tools.
  </p>

  <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-12 px-6">
    {[
      {
        title: "Thermal Imaging Cameras",
        desc: "Detect hidden leaks using advanced infrared technology without damaging walls.",
      },
      {
        title: "Moisture Meter Analysis",
        desc: "Measure moisture levels accurately in ceilings, walls, and floors.",
      },
      {
        title: "Pressure Testing Systems",
        desc: "Pinpoint leaks efficiently without invasive demolition work.",
      },
    ].map((item, i) => (
      <div
        key={i}
        className="relative group bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl hover:-translate-y-3 transition-all duration-500 border border-gray-200"
      >
        {/* Title & Description */}
        <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
        <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>

        {/* Subtle Amber Glow on Hover */}
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-amber-300/20 to-transparent opacity-0 group-hover:opacity-100 transition-all pointer-events-none"></div>
      </div>
    ))}
  </div>
</section>
{/* WHY OLD METHODS FAIL */}
<section className="py-36 bg-black text-white">
  <div className="max-w-5xl mx-auto px-6 text-center">
    <h2 className="text-amber-500 text-5xl font-serif font-bold mb-8">
      Why Traditional Methods Fail
    </h2>
    <p className="text-gray-300 text-lg mb-16">
      Hammering walls and guessing leak locations often causes more damage than solution.
    </p>

    <div className="grid md:grid-cols-3 gap-12">
      {[
        {
          title: "Random Breaking",
          desc: "Walls are broken without knowing exact leak location."
        },
        {
          title: "Time Wasted",
          desc: "Days of inspection with no accurate results."
        },
        {
          title: "High Repair Cost",
          desc: "Extra damage increases renovation expenses."
        }
      ].map((item, i) => (
        <div key={i} className="border border-white/20 rounded-2xl p-8">
          <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
          <p className="text-gray-400 text-sm">{item.desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* FINAL CTA */}
      <section className="py-40 text-center bg-white">
        <h2 className="text-amber-600 text-6xl font-serif mb-6">
          Find the leak.<br />Before it finds you.
        </h2>
        <p className="text-gray-600 text-lg mb-10">
          Book a professional leak inspection today.
        </p>
        <button
          onClick={() => setIsModalOpen(true)}
          className="
            px-14 py-5 rounded-full 
            bg-amber-600 text-white 
            text-lg font-medium
            shadow-lg
            hover:scale-105 transition
          "
        >
          Schedule Free Visit
        </button>
      </section>

      <BookConsultModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default LeakDetectionCinematic;
